import styled from 'styled-components';

export const SLoaderWrapper = styled.div`
    width: 100%;
    min-height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
